<template>
  <div class="owner-query-page">
    <!-- 查询卡片 -->
    <a-card class="filter-card" :bordered="false">
      <template #title>
        <span>业主信息查询</span>
      </template>

      <div class="hint-row">
        <span class="muted">（根据楼号、房号查询业主信息）</span>
      </div>

      <a-form layout="inline" @submit.prevent>
        <a-form-item label="楼号">
          <a-input
            v-model="queryBuilding"
            allowClear
            placeholder="请输入楼号"
            style="width: 160px"
            @pressEnter="queryOwner"
          />
        </a-form-item>

        <a-form-item label="房号">
          <a-input
            v-model="queryRoom"
            allowClear
            placeholder="请输入房号"
            style="width: 160px"
            @pressEnter="queryOwner"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" :loading="loadingQuery" @click="queryOwner">
            查询业主
          </a-button>

          <!-- ✅ 新增：业主账单查询 -->
          <a-button
            type="default"
            style="margin-left: 8px"
            :loading="loadingBills"
            @click="queryOwnerBills"
          >
            业主账单查询
          </a-button>

          <a-button style="margin-left: 8px" @click="resetAll" :disabled="loadingQuery || loadingUpdate || loadingBills">
            重置
          </a-button>

          <a-button style="margin-left: 8px" icon="plus" @click="goToOwnerEntry">
            新增业主
          </a-button>
          <a-button style="margin-left: 8px" @click="downloadBatchTemplate">
            批量建立业主信息模板下载
          </a-button>
          <a-button style="margin-left: 8px" @click="goToBatchCreate">
            批量建立业主信息
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>

    <!-- 结果卡片：业主信息 -->
    <a-card v-if="showOwnerInfo" class="content-card" :bordered="false">
      <template #title>
        <span>业主信息</span>
      </template>

      <a-spin :spinning="loadingUpdate">
        <a-form class="owner-form" @submit.prevent>
          <a-row :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item label="楼号">
                <a-input v-model="ownerInfo.building" disabled />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item label="房号">
                <a-input v-model="ownerInfo.room" disabled />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item label="业主姓名" required>
                <a-input v-model="ownerInfo.owner_name" placeholder="请输入业主姓名" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item label="联系电话" required>
                <a-input v-model="ownerInfo.phone" placeholder="请输入手机号" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item label="房屋面积（㎡）">
                <a-input-number
                  v-model="ownerInfo.area"
                  :min="0"
                  :step="0.01"
                  style="width: 100%"
                  placeholder="可选"
                />
              </a-form-item>
            </a-col>

            <a-col :xs="24" :md="12">
              <a-form-item label="房屋状态">
                <a-select v-model="ownerInfo.status" allowClear placeholder="请选择" style="width: 100%">
                  <a-select-option value="正常">正常</a-select-option>
                  <a-select-option value="停用">停用</a-select-option>
                  <a-select-option value="出租">出租</a-select-option>
                  <a-select-option value="自住">自用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item label="业主类型">
                <a-select v-model="ownerInfo.owner_type" allowClear placeholder="请选择" style="width: 100%">
                  <a-select-option :value="1">业主</a-select-option>
                  <a-select-option :value="2">租户</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item label="催缴提前天数">
                <a-input-number
                  v-model="ownerInfo.reminder_days"
                  :min="0"
                  :step="1"
                  style="width: 100%"
                  placeholder="可选"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 收款账号信息（新增） -->
          <a-row :gutter="16">
            <a-col :xs="24" :md="24">
              <a-form-item label="收款账号信息">
                <div v-if="currentOwnerAccountInfoText" style="margin-bottom: 8px;">
                  <a-alert type="info" show-icon :message="'当前收款账号：' + currentOwnerAccountInfoText" />
                </div>

                <a-select
                  v-model="ownerInfo.pay_account_id"
                  placeholder="选择收款账号（会同步填入下方三项）"
                  style="width: 100%"
                  allowClear
                  :loading="payAccountsLoading"
                  @change="onPayAccountChange"
                >
                  <a-select-option
                    v-for="a in payAccounts"
                    :key="a.id"
                    :value="a.id"
                    :disabled="a.active === false"
                  >
                    {{ a.bank_account_name }}｜{{ a.bank_account_no }}｜{{ a.bank_name }}
                    <span v-if="a.active === false" style="color:#999;">（停用）</span>
                  </a-select-option>
                </a-select>
                <div class="muted" style="margin-top:6px" v-if="!payAccountsLoading && payAccounts.length===0">
                  暂无收款账号，请先去“管理收款账号信息”里新增并启用。
                </div>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 导入账单 & 预览账单 -->
          <a-row :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item label="导入账单">
                <a-upload
                  :before-upload="beforeUpload"
                  :show-upload-list="false"
                  accept=".xlsx, .xls"
                  :custom-request="handleFileUpload"
                >
                  <a-button icon="upload">点击上传账单</a-button>
                </a-upload>

                <a-button style="margin-left:8px" icon="download" @click="downloadBillTemplate">
                  下载标准模板
                </a-button>
              </a-form-item>
            </a-col>

            <a-col :xs="24" :md="12">
              <a-form-item label=" ">
                <a-button
                  type="default"
                  @click="previewBillData"
                  :disabled="!ownerInfo || !(ownerInfo.rental_periods && ownerInfo.rental_periods.length)"
                >
                  预览账单数据
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>

          <div class="action-row">
            <a-button type="primary" :loading="loadingUpdate" @click="updateOwner">
              更新业主信息
            </a-button>
            <a-button
              style="margin-left: 12px"
              icon="download"
              :disabled="!ownerInfo || !ownerInfo.id"
              @click="exportOwnerPaymentRecords"
            >
              导出缴费与付款记录
            </a-button>

            <a-button
              type="danger"
              style="margin-left: 12px"
              :loading="loadingDelete"
              @click="confirmDeleteOwner"
            >
              删除业主
            </a-button>
          </div>
        </a-form>
      </a-spin>
    </a-card>

    <!-- ✅ 新增：业主账单信息卡片 -->
    <a-card
      v-if="showBillsCard"
      ref="billsCard"
      class="content-card bills-card"
      :bordered="false"
    >
      <template #title>
        <span>业主账单信息</span>
      </template>

      <a-spin :spinning="loadingBills">
        <a-alert
          v-if="billsError"
          type="error"
          show-icon
          :message="billsError"
          style="margin-bottom: 12px"
        />
        <div class="muted" style="margin-bottom: 12px" v-if="billsOwnerInfoText">
          {{ billsOwnerInfoText }}
          <span v-if="billsCount != null"> · 共 {{ billsCount }} 条</span>
        </div>
        <!-- ✅ 筛选栏 -->
        <div class="bills-filter-row">
          <!-- 支付状态 -->
          <a-select
            v-model="billFilterPayStatus"
            style="width: 160px"
            placeholder="支付状态"
            allowClear
          >
            <a-select-option value="all">全部</a-select-option>
            <a-select-option value="0">未支付</a-select-option>
            <a-select-option value="1">已支付</a-select-option>
          </a-select>

          <!-- 账单日期范围（起始/结束） -->
          <a-range-picker
            v-model="billFilterDateRange"
            style="width: 280px"
            format="YYYY-MM-DD"
            :allowClear="true"
            placeholder="['开始日期','结束日期']"
          />

          <a-button
            style="margin-left:auto"
            icon="reload"
            @click="resetBillsFilters"
          >
            清空筛选
          </a-button>
        </div>
        
        <a-table
          :data-source="filteredBillsList"
          :columns="billsColumns"
          :pagination="{ pageSize: 10, showTotal: total => `共 ${total} 条` }"
          :rowKey="record => record.bill_type + '-' + record.id"
          :scroll="{ x: 900 }"
        />
      </a-spin>
    </a-card>

    <!-- 账单数据预览弹窗 -->
    <a-modal
      :visible="previewVisible"
      title="账单数据预览"
      :width="'80%'"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-table
        :data-source="(ownerInfo && ownerInfo.rental_periods) ? ownerInfo.rental_periods : []"
        :columns="billColumns"
        rowKey="period_number"
        :scroll="{ x: 1100 }"
      />
    </a-modal>
  </div>
</template>

<script>
import request from "@/utils/request";
import * as XLSX from "xlsx";

export default {
  name: "OwnerQuery",
  data() {
    return {
      queryBuilding: "",
      queryRoom: "",
      ownerInfo: null,
      loadingQuery: false,
      loadingUpdate: false,
      showOwnerInfo: false,
      loadingDelete: false,

      // ✅ 账单筛选
      billFilterPayStatus: "all",     // all | "0" | "1"
      billFilterDateRange: null,      // [moment, moment] 或 null

      // ✅ 当前用户 team
      teamId: null,
      communityName: "",

      payAccountsLoading: false,
      payAccounts: [],
      ownerAccountInfoFromApi: null,

      // ✅ 账单预览弹窗
      previewVisible: false,
      billColumns: [
        { title: "租期序号", dataIndex: "period_number" },
        { title: "款项类型", dataIndex: "payment_type" },
        { title: "起始日期", dataIndex: "start_date" },
        { title: "结束日期", dataIndex: "end_date" },
        { title: "应收日期", dataIndex: "due_date" },
        { title: "应收合计", dataIndex: "receivable_amount" },
        { title: "实收合计", dataIndex: "received_amount" },
        { title: "房租", dataIndex: "rent_amount" },
        { title: "物业费", dataIndex: "property_fee_amount" },
      ],

      // ✅ 新增：业主账单查询数据
      loadingBills: false,
      billsError: "",
      billsCount: null,
      billsOwnerInfo: null,
      billsList: [],
      showBillsCard: false,

      billsColumns: [
        { title: "账单ID", dataIndex: "id", width: 90 },
        { title: "账单类型", dataIndex: "bill_type_label", width: 120 },
        { title: "起始日期", dataIndex: "period_start", width: 140, customRender: (t) => this.formatCNDateOnly(t) },
        { title: "结束日期", dataIndex: "period_end", width: 140, customRender: (t) => this.formatCNDateOnly(t) },
        { title: "金额", dataIndex: "amount", width: 120, customRender: (t) => this.formatMoney(t) },
        {
          title: "支付状态",
          dataIndex: "is_paid",
          width: 100,
          customRender: (v) => (v ? "已支付" : "未支付"),
        },
        {
          title: "操作",
          key: "actions",
          width: 100,
          fixed: "right",
          customRender: (text, record) => {
            return this.$createElement(
              "a-button",
              {
                props: { type: "danger", size: "small" },
                on: { click: () => this.confirmDeleteBill(record) },
              },
              "删除"
            );
          },
        },
      ],

    };
  },
  created() {
    this.initPage();
    this.resetAll();
  },
  activated() {
    this.resetAll();
  },
  computed: {
    currentOwnerAccountInfoText() {
      const a = this.ownerAccountInfoFromApi;
      if (!a) return "";
      const companyName = a.companyName || "";
      const bankAccount = a.bankAccount || "";
      const bankName = a.bankName || "";
      if (!companyName && !bankAccount && !bankName) return "";
      return `${companyName} / ${bankAccount} / ${bankName}`.replace(/\s*\/\s*$/, "");
    },

    // ✅ 账单卡片标题辅助信息
    billsOwnerInfoText() {
      const o = this.billsOwnerInfo;
      if (!o) return "";
      const name = o.owner_name ? String(o.owner_name) : "";
      const phone = o.phone ? String(o.phone) : "";
      const building = o.building != null ? String(o.building) : "";
      const room = o.room != null ? String(o.room) : "";
      const namePart = name ? `业主：${name}` : "业主：-";
      const phonePart = phone ? `电话：${phone}` : "电话：-";
      const roomPart = (building && room) ? `房屋：${building}号楼${room}室` : "";
      return [roomPart, namePart, phonePart].filter(Boolean).join(" · ");
    },

    sortedBillsList() {
      const list = Array.isArray(this.billsList) ? this.billsList.slice() : [];

      const toTime = (v) => {
        if (!v) return Number.POSITIVE_INFINITY;

        const s = String(v).trim();

        // 兼容 "2026-02-01 00:00:00" / "2026-02-01T00:00:00"
        const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
        if (m) {
          const y = Number(m[1]);
          const mo = Number(m[2]) - 1;
          const d = Number(m[3]);
          const dt = new Date(y, mo, d); // 本地 00:00:00
          const t = dt.getTime();
          return Number.isNaN(t) ? Number.POSITIVE_INFINITY : t;
        }

        // 兼容 "Sun, 01 Feb 2026 00:00:00 GMT"
        const dt2 = new Date(s);
        const t2 = dt2.getTime();
        return Number.isNaN(t2) ? Number.POSITIVE_INFINITY : t2;
      };

      list.sort((a, b) => {
        const ta = toTime(a.period_start);
        const tb = toTime(b.period_start);
        if (ta !== tb) return ta - tb;
        return Number(a.id || 0) - Number(b.id || 0);
      });

      return list;
    },

    filteredBillsList() {
      const list = Array.isArray(this.billsList) ? this.billsList.slice() : [];

      // 统一把日期转成“当天00:00”的 time（便于范围比较）
      const toDayTime = (v) => {
        if (!v) return null;
        const s = String(v).trim();

        // 1) yyyy-mm-dd...
        const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
        if (m) {
          const y = Number(m[1]);
          const mo = Number(m[2]) - 1;
          const d = Number(m[3]);
          const dt = new Date(y, mo, d);
          const t = dt.getTime();
          return Number.isNaN(t) ? null : t;
        }

        // 2) RFC / 其它格式
        const dt2 = new Date(s);
        const t2 = dt2.getTime();
        return Number.isNaN(t2) ? null : new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()).getTime();
      };

      // ====== 1) 支付状态筛选 ======
      const ps = this.billFilterPayStatus;
      let filtered = list;
      if (ps !== "all" && ps !== null && ps !== undefined && ps !== "") {
        const wantPaid = (ps === "1");
        filtered = filtered.filter(b => !!b.is_paid === wantPaid);
      }

      // ====== 2) 日期范围筛选（按 start_date 落在范围内） ======
      // range picker 返回 [moment/dayjs, moment/dayjs]
      const range = this.billFilterDateRange;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        const start = range[0];
        const end = range[1];

        // 取 YYYY-MM-DD，再转 time，避免时分秒影响
        const startStr = typeof start.format === "function" ? start.format("YYYY-MM-DD") : "";
        const endStr = typeof end.format === "function" ? end.format("YYYY-MM-DD") : "";

        const tStart = toDayTime(startStr);
        const tEnd = toDayTime(endStr);

        if (tStart != null && tEnd != null) {
          filtered = filtered.filter(b => {
            const tb = toDayTime(b.period_start);
            if (tb == null) return false;
            return tb >= tStart && tb <= tEnd;
          });
        }
      }

      // ====== 3) 排序（仍按 start_date 升序；同日兜底 period/id） ======
      const toTime = (v) => {
        const t = toDayTime(v);
        return t == null ? Number.POSITIVE_INFINITY : t;
      };

      filtered.sort((a, b) => {
        const ta = toTime(a.period_start);
        const tb = toTime(b.period_start);
        if (ta !== tb) return ta - tb;
        return Number(a.id || 0) - Number(b.id || 0);
      });

      return filtered;
    },

  },
  methods: {
    async initPage() {
      await this.fetchMyTeam();
      this.previewVisible = false;
      if (this.ownerInfo) this.ownerInfo.rental_periods = [];
      await this.fetchPayAccounts();
    },

    async fetchMyTeam() {
      try {
        const res = await request({ url: "/manage_data/my_team/", method: "get" });
        const data = res && res.data ? res.data : res;
        this.teamId = data.team_id;
        this.communityName = data.community_name || "";
      } catch (e) {
        console.error(e);
        this.teamId = null;
        this.communityName = "";
        this.showMessage("获取当前用户所属小区(team_id)失败，请重新登录或联系管理员", "error");
      }
    },

    showMessage(msg, type = "info") {
      if (this.$message && this.$message[type]) this.$message[type](msg);
      else alert(msg);
    },

    // ✅ 只显示日期：YYYY年M月D日（不显示时分秒）
    // 兼容：
    // - "2026-02-01 00:00:00" / "2026-02-01T00:00:00"
    // - "Sun, 01 Feb 2026 00:00:00 GMT"（第三方 RFC 格式）
    formatCNDateOnly(s) {
      if (!s) return "-";
      const str = String(s).trim();

      // 1) 先匹配 yyyy-mm-dd（最常见）
      const m = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
      if (m) {
        const y = m[1];
        const mo = String(Number(m[2])); // 不补0，显示自然
        const d = String(Number(m[3]));
        return `${y}年${mo}月${d}日`;
      }

      // 2) 再尝试 RFC / 其它可被 Date 解析的格式
      const d2 = new Date(str);
      if (!Number.isNaN(d2.getTime())) {
        const y = d2.getFullYear();
        const mo = d2.getMonth() + 1;
        const d = d2.getDate();
        return `${y}年${mo}月${d}日`;
      }

      // 3) 兜底：原样返回
      return str;
    },

    // ✅ 金额格式化
    formatMoney(v) {
      const n = Number(v || 0);
      if (Number.isNaN(n)) return "-";
      return `¥${n.toFixed(2)}`;
    },

    // ✅ 日期格式化（你原来就有）
    formatCNDateTimeLocalStr(s, withSeconds = false) {
      if (!s) return "-";
      const str = String(s).trim();
      const m = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/);
      if (!m) {
        // 兼容 "Tue, 30 Dec 2025 16:07:29 GMT" 这种 RFC 字符串
        const d2 = new Date(str);
        if (!Number.isNaN(d2.getTime())) {
          const y = d2.getFullYear();
          const mo = d2.getMonth() + 1;
          const d = d2.getDate();
          const hh = String(d2.getHours()).padStart(2, "0");
          const mm = String(d2.getMinutes()).padStart(2, "0");
          const ss = String(d2.getSeconds()).padStart(2, "0");
          return withSeconds ? `${y}年${mo}月${d}日 ${hh}:${mm}:${ss}` : `${y}年${mo}月${d}日 ${hh}:${mm}`;
        }
        return str;
      }

      const y = m[1];
      const mo = String(m[2]);
      const d = String(m[3]);
      const hh = m[4] !== undefined ? String(m[4]).padStart(2, "0") : "00";
      const mm = m[5] !== undefined ? String(m[5]).padStart(2, "0") : "00";
      const ss = m[6] !== undefined ? String(m[6]).padStart(2, "0") : "00";

      return withSeconds ? `${y}年${mo}月${d}日 ${hh}:${mm}:${ss}` : `${y}年${mo}月${d}日 ${hh}:${mm}`;
    },

    confirmDeleteBill(bill) {
      if (!bill || !bill.id) return;

      if (!this.teamId) {
        this.showMessage("无法获取当前用户 team_id，请刷新页面或重新登录", "error");
        return;
      }

      this.$confirm({
        title: "确认删除该条账单？",
        content: `账单ID：${bill.id}。此操作不可恢复。`,
        okText: "删除",
        cancelText: "取消",
        okType: "danger",
        onOk: () => this.deleteBill(bill),
      });
    },

    getBillApiPath(bill) {
      if (bill.bill_type === "electric") return "/electricity/bills/";
      if (bill.bill_type === "water") return "/electricity/water-bills/";
      return "/electricity/property-bills/";
    },

    async deleteBill(bill) {
      if (!bill || !bill.id) return;
      if (!this.teamId) return this.showMessage("无法获取 team_id", "error");

      if (this.loadingBills) return;

      this.loadingBills = true;
      try {
        const apiPath = this.getBillApiPath(bill);
        await request({
          url: `${apiPath}${bill.id}/`,
          method: "delete",
        });

        this.billsList = (this.billsList || []).filter(
          (x) => !(Number(x.id) === Number(bill.id) && x.bill_type === bill.bill_type)
        );

        if (this.billsCount != null) this.billsCount = Math.max(0, Number(this.billsCount) - 1);

        this.showMessage("删除成功", "success");
      } catch (e) {
        console.error(e);
        const errMsg = e.response?.data?.detail || e.response?.data?.error || "网络错误，请重试";
        this.showMessage(errMsg, "error");
      } finally {
        this.loadingBills = false;
      }
    },


    // ✅ 业主账单查询（改用本地 API）
    async queryOwnerBills() {
      const building = String(this.queryBuilding || "").trim();
      const room = String(this.queryRoom || "").trim();

      if (!building || !room) {
        this.showMessage("请先填写楼号和房号", "warning");
        return;
      }
      if (!this.teamId) {
        this.showMessage("无法获取当前用户 team_id，请刷新页面或重新登录", "error");
        return;
      }

      // 清空旧结果
      this.loadingBills = true;
      this.billsError = "";
      this.billsCount = null;
      this.billsOwnerInfo = null;
      this.billsList = [];
      this.showBillsCard = true;
      this.resetBillsFilters();

      // 互斥显示：只看账单，隐藏业主信息卡片
      this.showOwnerInfo = false;
      this.ownerInfo = null;
      this.ownerAccountInfoFromApi = null;
      this.previewVisible = false;

      try {
        // ✅ 第一步：根据楼号房号查询业主
        const ownerRes = await request({
          url: "/electricity/accounts/",
          method: "get",
          params: { building_no: building, unit_no: room },
        });

        const ownerData = ownerRes && ownerRes.data ? ownerRes.data : ownerRes;
        const ownerList = Array.isArray(ownerData) ? ownerData : (ownerData.results || []);

        if (ownerList.length === 0) {
          this.billsError = "未找到该业主信息";
          this.showMessage(this.billsError, "warning");
          return;
        }

        const owner = ownerList[0];
        this.billsOwnerInfo = {
          owner_name: owner.owner_name,
          phone: owner.contact_phone,
          building: owner.building_no,
          room: owner.unit_no,
        };

        // ✅ 第二步：根据业主 ID 查询所有类型账单（统一接口）
        const billsRes = await request({
          url: `/electricity/accounts/${owner.id}/all-bills/`,
          method: "get",
        });

        const billsData = billsRes && billsRes.data ? billsRes.data : billsRes;
        const list = billsData.bills || [];

        this.billsCount = list.length;
        this.billsList = list;

        this.showMessage("账单查询成功", "success");
        this.scrollToBillsCard();
      } catch (e) {
        console.error(e);
        this.billsError = "网络错误，请重试";
        this.showMessage(this.billsError, "error");
      } finally {
        this.loadingBills = false;
      }
    },

    // ====== 下面保持你原逻辑（我只删了不相关的注释）======

    beforeUpload(file) {
      const isExcel =
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) this.showMessage("请上传Excel格式的账单文件！", "error");
      return isExcel;
    },

    excelDateToYMD(val) {
      if (val === null || val === undefined || val === "") return "";

      if (val instanceof Date) {
        const y = val.getFullYear();
        const m = String(val.getMonth() + 1).padStart(2, "0");
        const d = String(val.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
      }

      if (typeof val === "string") {
        const s = val.trim();
        if (!s) return "";
        const m = s.match(/^(\d{4})[\/\-\.](\d{1,2})[\/\-\.](\d{1,2})/);
        if (m) return `${m[1]}-${String(m[2]).padStart(2, "0")}-${String(m[3]).padStart(2, "0")}`;
        return s;
      }

      if (typeof val === "number") {
        const d = XLSX.SSF.parse_date_code(val);
        if (d && d.y && d.m && d.d) {
          return `${d.y}-${String(d.m).padStart(2, "0")}-${String(d.d).padStart(2, "0")}`;
        }
      }

      return String(val);
    },

    toNumber(val) {
      if (val === null || val === undefined || val === "") return null;
      if (typeof val === "number") return val;
      const s = String(val).replace(/[,\s￥¥]/g, "").trim();
      if (!s) return null;
      const n = Number(s);
      return Number.isNaN(n) ? null : n;
    },

    handleFileUpload({ file }) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];

          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: true });
          if (!jsonData || jsonData.length < 2) {
            this.showMessage("Excel内容为空或缺少数据行", "error");
            return;
          }

          const headerRow = jsonData[0];
          const headerMap = this.buildHeaderIndexMap(headerRow);

          const ALIAS = {
            period_number: ["租期序号", "期数", "期号", "period_number"],
            payment_type: ["款项类型", "付款类型", "费用类型", "payment_type"],
            start_date: ["起始日期", "开始日期", "start_date"],
            end_date: ["结束日期", "截止日期", "end_date"],
            due_date: ["应收日期", "缴费日期", "到期日期", "due_date"],
            receivable_amount: ["应收合计", "应收金额", "应收", "receivable_amount"],
            received_amount: ["实收合计", "实收金额", "实收", "received_amount"],
            rent_amount: ["房租", "租金金额", "rent_amount"],
            property_fee_amount: ["物业费", "物业费金额", "property_fee_amount"],
          };

          const rows = jsonData.slice(1);

          const rentalPeriods = rows
            .filter((row) => row && row.length)
            .map((row) => {
              const period_number = this.getCellByHeader(row, headerMap, ALIAS.period_number);
              const payment_type = this.getCellByHeader(row, headerMap, ALIAS.payment_type);

              if ((period_number == null || period_number === "") && (!payment_type || !String(payment_type).trim())) {
                return null;
              }

              const startRaw = this.getCellByHeader(row, headerMap, ALIAS.start_date);
              const endRaw = this.getCellByHeader(row, headerMap, ALIAS.end_date);
              const dueRaw = this.getCellByHeader(row, headerMap, ALIAS.due_date);

              const receivableRaw = this.getCellByHeader(row, headerMap, ALIAS.receivable_amount);
              const receivedRaw = this.getCellByHeader(row, headerMap, ALIAS.received_amount);

              const rentRaw = this.getCellByHeader(row, headerMap, ALIAS.rent_amount);
              const propRaw = this.getCellByHeader(row, headerMap, ALIAS.property_fee_amount);

              return {
                period_number: period_number != null && period_number !== "" ? Number(period_number) : null,
                payment_type: payment_type != null ? String(payment_type).trim() : "",
                start_date: this.excelDateToYMD(startRaw),
                end_date: this.excelDateToYMD(endRaw),
                due_date: this.excelDateToYMD(dueRaw),
                receivable_amount: this.toNumber(receivableRaw),
                received_amount: this.toNumber(receivedRaw),
                rent_amount: this.toNumber(rentRaw),
                property_fee_amount: this.toNumber(propRaw),
              };
            })
            .filter(Boolean);

          if (!this.ownerInfo) {
            this.showMessage("请先查询到业主信息后再导入账单", "warning");
            return;
          }

          this.ownerInfo.rental_periods = rentalPeriods;
          this.showMessage(`账单导入成功！共 ${rentalPeriods.length} 条`, "success");
        } catch (err) {
          console.error(err);
          this.showMessage("解析Excel失败，请确认模板格式正确", "error");
        }
      };

      reader.readAsBinaryString(file);
    },

    previewBillData() {
      this.previewVisible = true;
    },
    handleOk() {
      this.previewVisible = false;
    },
    handleCancel() {
      this.previewVisible = false;
    },

    normalizeOwnerInfo(raw, comp_id, team_id) {
      const base = raw || {};
      return {
        building: base.building || this.queryBuilding,
        room: base.room || this.queryRoom,
        owner_name: base.owner_name || "",
        phone: base.phone || "",
        id_card: base.id_card || "",
        area: base.area != null ? Number(base.area) : null,
        status: base.status || "正常",
        owner_type: base.owner_type != null ? Number(base.owner_type) : null,
        reminder_days: base.reminder_days != null ? Number(base.reminder_days) : null,
        comp_id,
        team_id,

        bank_account_name: base.bank_account_name || "",
        bank_account_no: base.bank_account_no || "",
        bank_name: base.bank_name || "",

        pay_account_id: null,
        rental_periods: Array.isArray(base.rental_periods) ? base.rental_periods : [],
      };
    },
    
    downloadBillTemplate() {
      const headers = [
        "租期序号",
        "款项类型",
        "起始日期",
        "结束日期",
        "应收日期",
        "应收合计",
        "实收合计",
        "房租",
        "物业费",
      ];

      const exampleRow = [
        1,
        "租金",
        "2025-03-01",
        "2025-03-31",
        "2025-03-05",
        8600,
        0,
        8200,
        400,
      ];

      const ws = XLSX.utils.aoa_to_sheet([headers, exampleRow]);
      ws["!cols"] = [
        { wch: 10 },
        { wch: 12 },
        { wch: 14 },
        { wch: 14 },
        { wch: 14 },
        { wch: 12 },
        { wch: 12 },
        { wch: 10 },
        { wch: 10 },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "账单导入模板");
      XLSX.writeFile(wb, "业主账单导入模板.xlsx");
    },

    async queryOwner() {
      const building = String(this.queryBuilding || "").trim();
      const room = String(this.queryRoom || "").trim();
      if (!building || !room) {
        this.showMessage("请填写楼号和房号", "warning");
        return;
      }
      if (!this.teamId) {
        this.showMessage("无法获取当前用户 team_id，请刷新页面或重新登录", "error");
        return;
      }

      // ✅ 查询业主时，也把“业主账单信息”清掉，避免误会
      this.showBillsCard = false;
      this.billsError = "";
      this.billsCount = null;
      this.billsOwnerInfo = null;
      this.billsList = [];
      if (typeof this.resetBillsFilters === "function") this.resetBillsFilters();

      this.previewVisible = false;
      this.loadingQuery = true;
      this.showOwnerInfo = false;
      this.ownerInfo = null;

      try {
        // ✅ 调用本地 API 查询业主
        const res = await request({
          url: "/electricity/accounts/",
          method: "get",
          params: { building_no: building, unit_no: room },
        });

        const data = res && res.data ? res.data : res;
        const results = Array.isArray(data) ? data : (data.results || []);

        if (results.length > 0) {
          const info = results[0];
          this.ownerInfo = this.normalizeOwnerInfoLocal(info);
          this.ownerAccountInfoFromApi = this.pickOwnerAccountInfoLocal(info);
          if (this.ownerInfo) this.ownerInfo.rental_periods = [];
          this.showOwnerInfo = true;
          this.showMessage("查询成功", "success");
        } else {
          this.showMessage("未找到该业主信息", "warning");
        }
      } catch (e) {
        console.error(e);
        this.showMessage("网络错误，请重试", "error");
      } finally {
        this.loadingQuery = false;
      }
    },

    // ✅ 本地 API 返回数据规整（字段名映射）
    normalizeOwnerInfoLocal(info) {
      return {
        id: info.id,
        building: info.building_no || "",
        room: info.unit_no || "",
        owner_name: info.owner_name || "",
        phone: info.contact_phone || "",
        id_card: info.id_card || "",
        area: info.floor_area != null ? Number(info.floor_area) : null,
        status: info.status || "正常",
        owner_type: info.owner_type != null ? Number(info.owner_type) : null,
        reminder_days: info.reminder_days != null ? Number(info.reminder_days) : null,
        team_id: info.team_id,
        pay_account_id: info.pay_account || null,
        pay_account_detail: info.pay_account_detail || null,
        rental_periods: [],
      };
    },

    // ✅ 本地 API 收款账号信息提取
    pickOwnerAccountInfoLocal(info) {
      const detail = info.pay_account_detail;
      if (!detail) return null;
      return {
        companyName: detail.bank_account_name || "",
        bankAccount: detail.bank_account_no || "",
        bankName: detail.bank_name || "",
      };
    },

    pickOwnerAccountInfo(info) {
      if (info && info.accountInfo && typeof info.accountInfo === "object") {
        const a = info.accountInfo;
        return {
          companyName: a.companyName || "",
          bankAccount: a.bankAccount || "",
          bankName: a.bankName || "",
        };
      }

      const s = info && info.account_info;
      if (typeof s === "string" && s.trim()) {
        try {
          const obj = JSON.parse(s);
          return {
            companyName: obj.companyName || "",
            bankAccount: obj.bankAccount || "",
            bankName: obj.bankName || "",
          };
        } catch (e) {}
      }
      return null;
    },

    async updateOwner() {
      if (!this.ownerInfo) return;

      if (!this.teamId) {
        this.showMessage("无法获取当前用户 team_id，请刷新页面或重新登录", "error");
        return;
      }

      const info = this.ownerInfo;

      // 校验
      if (!info.building || !info.room) return this.showMessage("缺少楼号或房号，无法更新", "error");
      if (!String(info.owner_name || "").trim()) return this.showMessage("请输入业主姓名", "warning");
      if (!String(info.phone || "").trim()) return this.showMessage("请输入联系电话", "warning");

      const accountId = info.id;
      if (!accountId) {
        this.showMessage("业主ID缺失，无法更新", "error");
        return;
      }


      this.loadingUpdate = true;
      try {
        // 构建本地 API payload
        const localPayload = {
          owner_name: String(info.owner_name).trim(),
          contact_phone: String(info.phone).trim(),
          id_card: info.id_card ? String(info.id_card).trim() : "",
          floor_area: info.area != null ? Number(info.area) : null,
          status: info.status || "正常",
          owner_type: info.owner_type != null ? Number(info.owner_type) : 1,
          reminder_days: info.reminder_days != null ? Number(info.reminder_days) : 0,
          pay_account: info.pay_account_id || null,
        };

        const res = await request({
          url: `/electricity/accounts/${accountId}/`,
          method: "patch",
          data: localPayload,
        });

        const result = res && res.data ? res.data : res;
        if (result && result.id) {
          this.showMessage("更新成功", "success");

          // 如果有新导入的账单，批量创建
          if (info.rental_periods && info.rental_periods.length > 0) {
            await this.createPropertyBillsForOwner(accountId, info.rental_periods);
          }

          this.resetAll();
        } else {
          this.showMessage((result && result.detail) || "更新失败", "error");
        }
      } catch (e) {
        console.error(e);
        const errMsg = e.response?.data?.detail || e.response?.data?.error || "网络错误，请重试";
        this.showMessage(errMsg, "error");
      } finally {
        this.loadingUpdate = false;
      }
    },
    async exportOwnerPaymentRecords() {
      const accountId = this.ownerInfo?.id;
      if (!accountId) {
        this.showMessage("请先查询业主信息", "warning");
        return;
      }
      try {
        const blob = await request({
          url: `/owner-payment/accounts/${accountId}/export-records/`,
          method: "get",
          responseType: "blob",
        });
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, "0");
        const d = String(now.getDate()).padStart(2, "0");
        const building = this.ownerInfo?.building || "";
        const room = this.ownerInfo?.room || "";
        const filename = `业主缴费与付款记录_${building}-${room}_${y}${m}${d}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        this.showMessage("导出成功", "success");
      } catch (e) {
        console.error(e);
        const errMsg = e.response?.data?.detail || e.response?.data?.error || "导出失败，请重试";
        this.showMessage(errMsg, "error");
      }
    },

    async createPropertyBillsForOwner(accountId, rentalPeriods) {
      if (!rentalPeriods || rentalPeriods.length === 0) return;

      // 过滤掉缺少必填日期的记录
      const bills = rentalPeriods
        .filter(p => p.start_date && p.end_date)
        .map(p => ({
          account: accountId,
          period_number: p.period_number != null ? Number(p.period_number) : null,
          payment_type: p.payment_type || "物业费",
          start_date: p.start_date,
          end_date: p.end_date,
          due_date: p.due_date || null,
          receivable_amount: this.toNumber(p.receivable_amount) || 0,
          received_amount: this.toNumber(p.received_amount) || 0,
          rent_amount: this.toNumber(p.rent_amount) || null,
          property_fee_amount: this.toNumber(p.property_fee_amount) || null,
        }));
      
      if (bills.length === 0) return;

      try {
        await request({
          url: "/electricity/property-bills/batch/",
          method: "post",
          data: { bills },
        });
        this.showMessage(`已创建 ${bills.length} 条账单`, "success");
      } catch (err) {
        console.error("创建账单失败:", err);
        this.showMessage("业主更新成功，但账单创建失败", "warning");
      }
    },

    confirmDeleteOwner() {
      if (!this.ownerInfo) return;

      const building = String(this.ownerInfo.building || this.queryBuilding || "").trim();
      const room = String(this.ownerInfo.room || this.queryRoom || "").trim();

      if (!building || !room) {
        this.showMessage("缺少楼号或房号，无法删除", "error");
        return;
      }
      if (!this.teamId) {
        this.showMessage("无法获取当前用户 team_id，请刷新页面或重新登录", "error");
        return;
      }

      // ✅ 第一次确认（弹窗）
      this.$confirm({
        title: "确认删除该业主？",
        content: `将删除：楼号 ${building}，房号 ${room} 的业主信息。此操作不可恢复。`,
        okText: "继续",
        cancelText: "取消",
        okType: "danger",
        onOk: () => this.secondConfirmDeleteOwner(building, room),
      });
    },

    secondConfirmDeleteOwner(building, room) {
      // ✅ 第二次确认（要求输入 DELETE）
      let inputValue = "";

      this.$confirm({
        title: "二次确认：请输入 DELETE 继续",
        content: (
          <div>
            <div style="margin-bottom:8px;">
              为防止误删，请输入 <b>DELETE</b> 确认删除（不可恢复）
            </div>
            <a-input
              placeholder="请输入 DELETE"
              onChange={(e) => (inputValue = e.target.value)}
            />
          </div>
        ),
        okText: "确认删除",
        cancelText: "取消",
        okType: "danger",
        onOk: () => {
          if (String(inputValue || "").trim().toUpperCase() !== "DELETE") {
            this.showMessage("二次确认失败：请输入 DELETE", "error");
            // 这里抛出可以阻止弹窗关闭（AntD 会捕获 Promise reject）
            return Promise.reject(new Error("confirm text mismatch"));
          }
          return this.deleteOwner(building, room);
        },
      });
    },

    async deleteOwner(building, room) {
      this.loadingDelete = true;
      try {
        // ✅ 调用本地 API 删除业主（软删除）
        const accountId = this.ownerInfo?.id;
        if (!accountId) {
          this.showMessage("业主ID缺失，无法删除", "error");
          this.loadingDelete = false;
          return;
        }

        await request({
          url: `/electricity/accounts/${accountId}/`,
          method: "delete",
        });

        this.showMessage("删除成功", "success");
        this.resetAll();
      } catch (e) {
        console.error(e);
        const errMsg = e.response?.data?.detail || e.response?.data?.error || "网络错误，请重试";
        this.showMessage(errMsg, "error");
      } finally {
        this.loadingDelete = false;
      }
    },



    resetAll() {
      this.queryBuilding = "";
      this.queryRoom = "";
      this.previewVisible = false;

      if (this.ownerInfo) this.ownerInfo.rental_periods = [];
      this.ownerAccountInfoFromApi = null;
      this.ownerInfo = null;
      this.showOwnerInfo = false;

      // ✅ 新增：重置账单查询区域
      this.loadingBills = false;
      this.billsError = "";
      this.billsCount = null;
      this.billsOwnerInfo = null;
      this.billsList = [];
      this.showBillsCard = false;
    },

    async fetchPayAccounts () {
      this.payAccountsLoading = true
      try {
        const res = await request({
          url: "/manage_data/pay_accounts/",
          method: "get",
          params: { page_size: 5000 }
        })
        const data = res && res.data ? res.data : res
        const list = Array.isArray(data) ? data : (Array.isArray(data?.results) ? data.results : [])
        this.payAccounts = list
      } catch (e) {
        console.error(e)
        this.payAccounts = []
        this.showMessage("加载收款账号列表失败", "error")
      } finally {
        this.payAccountsLoading = false
      }
    },

    onPayAccountChange (id) {
      if (!this.ownerInfo) return
      const acc = this.payAccounts.find(x => Number(x.id) === Number(id))
      if (!acc) return

      // ✅ 选中账号后：自动回填到你后端字段命名
      this.ownerInfo.bank_account_name = acc.bank_account_name || ""
      this.ownerInfo.bank_account_no = acc.bank_account_no || ""
      this.ownerInfo.bank_name = acc.bank_name || ""

      console.log('[onPayAccountChange] ownerInfo=', this.ownerInfo)
    },

    // ✅ 表头工具函数（保持你原样）
    normalizeHeaderName(name) {
      return String(name || "")
        .replace(/\s+/g, "")
        .replace(/（/g, "(")
        .replace(/）/g, ")")
        .trim()
        .toLowerCase();
    },
    buildHeaderIndexMap(headerRow) {
      const map = {};
      (headerRow || []).forEach((h, idx) => {
        const k = this.normalizeHeaderName(h);
        if (!k) return;
        if (map[k] == null) map[k] = idx;
      });
      return map;
    },
    getCellByHeader(row, headerMap, aliases, fallbackIndex = null) {
      for (const a of aliases) {
        const key = this.normalizeHeaderName(a);
        const i = headerMap[key];
        if (i != null) return row[i];
      }
      if (fallbackIndex != null) return row[fallbackIndex];
      return undefined;
    },
    scrollToBillsCard() {
      this.$nextTick(() => {
        const el = this.$refs.billsCard && this.$refs.billsCard.$el
          ? this.$refs.billsCard.$el   // AntD Vue 的 a-card 是组件，需要取 $el
          : this.$refs.billsCard;

        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    resetBillsFilters() {
      this.billFilterPayStatus = "all";
      this.billFilterDateRange = null;
    },
    goToOwnerEntry() {
      this.$router.push({ name: "OwnerEntry" });
    },
    goToBatchCreate() {
      this.$router.push({ name: "OwnerBatchCreate" });
    },
    downloadBatchTemplate() {
      const header = [
        "楼号",
        "房号",
        "业主姓名",
        "手机号码",
        "房屋面积(㎡)",
        "催款提前天数",
        "水表初始读数",
        "电表初始读数",
      ];
      const ws = XLSX.utils.aoa_to_sheet([header]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "批量建立业主");
      XLSX.writeFile(wb, "批量建立业主信息模板.xlsx");
    },
  },
};
</script>

<style scoped>
.owner-query-page {
  padding: 16px;
}

.filter-card {
  margin-bottom: 16px;
  border-radius: 14px;
}
.content-card {
  border-radius: 14px;
}

.filter-card,
.content-card {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

.hint-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.action-row {
  margin-top: 8px;
}

.muted {
  color: rgba(0, 0, 0, 0.45);
}
.inline-kv {
  padding-top: 6px;
}

/* ✅ 新增：账单卡片与上方留点间距 */
.bills-card {
  margin-top: 16px;
}
.bills-filter-row{
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

</style>